import React, { useEffect, useRef } from 'react';

import { ReceiptTicket } from './ReceiptTicket';
import type { ReceiptData } from '../../utils/receipt';
import { triggerReceiptPrint } from '../../utils/receipt';

interface ReceiptRendererProps {
  data: ReceiptData | null;
  onComplete?: (mode?: 'print' | 'pdf') => void;
}

export function ReceiptRenderer({ data, onComplete }: ReceiptRendererProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!data) return;
    const timeout = window.setTimeout(() => {
      const mode = triggerReceiptPrint(data);
      onComplete?.(mode);
    }, 80);

    return () => window.clearTimeout(timeout);
  }, [data, onComplete]);

  if (!data) return null;

  return (
    <div aria-hidden="true" className="pointer-events-none">
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          #pos-receipt-container, #pos-receipt-container * {
            visibility: visible;
          }
          #pos-receipt-container {
            position: absolute;
            left: 0;
            top: 0;
            width: 80mm;
          }
        }
      `}</style>
      <div id="pos-receipt-container" ref={containerRef}>
        <ReceiptTicket data={data} />
      </div>
    </div>
  );
}

export default ReceiptRenderer;
